import { Pipe, PipeTransform } from '@angular/core';
import { isInteger } from 'appRootPath/utils';

const getZeroPaddedString = (num: number) => {
  return num.toLocaleString('en-US', {
    minimumIntegerDigits: 2,
    useGrouping: false
  });
};


@Pipe({
  name: 'millisecondsFormatter'
})
export class MillisecondsFormatterPipe implements PipeTransform {

  /**
   * Pipetransform - converts milliseconds to minutes and seconds
   * eg: 239000 => 03:59 minutes
   * eg: 40000 => 00:40 seconds
   */
  transform(value: number, args?: any): string {
    if (!isInteger(value) || value < 0) {
      return '';
    }
    const msInOneMin = 60 * 1000;
    const minutes: number = Math.trunc(value / msInOneMin);
    const seconds: number = (value - (minutes * msInOneMin)) / 1000;

    let response = '';
    if (minutes > 0) {
      response = `${getZeroPaddedString(minutes)}m ${getZeroPaddedString(seconds)}s`;
    } else {
      response = `${getZeroPaddedString(seconds)} seconds`;
    }
    return response;
  }

}
